import React from 'react';

import { flagStyles } from '../settings';

const SvgKW = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2904px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgKW;
